//@config
export default {
  task: {
    azmoon_execute_person_content: "v1/azmoon_execute_person/{0}/content",
    person_content: "v1/{0}/{1}/person_content",
    task: "v1/task",
    all_task: "v1/all_task",
    taskUpload: "v1/task/{0}/upload",
  },
};
